import { isNumber, last } from 'radash';

import { getFormPathFromDataModelPath, getNestedFormPathsFromDataModelPath } from './attributeFieldPathParser.shared';

const useAttributeFieldPathParser = () => {

    /**
     * Parses a form path and returns the last nested attribute name.
     *
     * A form path could be:
     *  - 'simple_string'              => 'simple_string'
     *  - 'collection.1.simple_string' => 'simple_string'
     *  - 'dimensional.de'             => 'dimensional'
     */
    const getAttributeNameFromFormPath = (path: string) => {
        const pathParts = path.split('.');

        if (pathParts.length === 1) {
            return path;
        }

        const lastPart = last(pathParts);

        pathParts.pop();
        const secondLastPart = last(pathParts.slice(-1));
        const parsedSecondLastPart = parseInt(secondLastPart || '');

        if (isNumber(parsedSecondLastPart)) {
            return lastPart;
        } else {
            return secondLastPart;
        }
    };

    return {
        getAttributeNameFromFormPath,
        getFormPathFromDataModelPath,
        getNestedFormPathsFromDataModelPath,
    };

};

export { useAttributeFieldPathParser };
